











































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Filter } from '../../../core/models';
import vColumnsResizable from '../../../../plugins/vue-columns-resizable'
import { itemsPerPageOptionsTable } from '../../../core/utils/table-utils';
@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: { }
})
export default class TableFilter extends Vue {
    @Prop() filters: Filter[];
    @Prop() selected: Filter[];
    @Prop() highlight: Filter;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;

    headers: any = [
        {
            text: 'Filtros',
            value: 'name',
            align: 'left'
        }
    ];

    @Emit()
    selectFilters(selectedFilters: Filter[]) {}

    @Emit()
    addSelectFilter(selectedFilter: Filter, selected: boolean) {}

    toggleAll() {
        if (this.selected.length) {
            this.selectFilters([]);
        } else {
            this.selectFilters([...this.filters]);
        }
    }

    handleSelectOne(selectedFilter: Filter, selected: boolean): void {
        this.addSelectFilter(selectedFilter, selected);
    }

    isActiveFilter(id: string): boolean {
        if (this.highlight) {
            return id === this.highlight.id;
        } else {
            return false;
        }
    }
}
